import React from "react";

/**
 * Mobile merchant shell (background + full-width content).
 * Bottom tab footer is only on AIMenuScreen and PromoScreenAds.
 */
const MobileAppLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-100 w-full overflow-x-hidden">
      <div className="min-h-screen w-full min-w-0">{children}</div>
    </div>
  );
};

export default MobileAppLayout;
